import React, { useRef, useEffect } from 'react';
import { Box, Flex, Tabs, TabPanels, TabPanel } from '@chakra-ui/core';

import { SecondaryTab, SecondaryTabList } from '../../../../common/components/Tabs';
import { getFolderPath } from '../../../../common/routes';
import { history } from '../../../../common/helpers/history';
import { BlocGTabForm } from './BlocGTabForm';
import { DocumentArchiveButton } from '../../../../common/components/DocumentArchiveButton';
import { BlocFormik } from '../../../../common/components/Form/BlocFormik';

export const BlocGTab2 = ({
  match: {
    params: { folderId, tabIndex, funderIndex },
  },
  blocId,
  blocG: { error, pending, needOwnerAutorisation, hasWorks, ...initialValues },
  onSubmit,
}) => {
  const formikRef = useRef();

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.setErrors(error && error.errors);
    }
  }, [error]);

  return (
    <BlocFormik
      innerRef={formikRef}
      initialValues={initialValues}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setTouched, setSubmitting }) => {
        // Relocked fields with lock
        document.querySelectorAll('[data-locked]').forEach(button => {
          if (
            button.getAttribute('data-locked') === 'false' &&
            button.getAttribute('data-default-locked') === 'true'
          )
            button.click();
        });

        return onSubmit({ ...initialValues, ...values }).then(() => {
          setTouched({});
          setSubmitting(false);
        });
      }}
    >
      {formik =>
        formik.values ? (
          <Tabs
            orientation="vertical"
            defaultIndex={0}
            index={Number(funderIndex) - 1}
            onChange={index =>
              history.push(getFolderPath(blocId, folderId, `${tabIndex}/${index + 1}`))
            }
          >
            <Flex alignItems="start" position="relative">
              <Box position="sticky" top={0}>
                <SecondaryTabList title="FINANCEURS" position="static">
                  {formik.values.eligibleFundersMonitoring &&
                    Object.entries(formik.values.eligibleFundersMonitoring).map(
                      ([key, eligibleFunder]) => (
                        <SecondaryTab w="200px" d="block" key={key}>
                          {eligibleFunder.label}
                        </SecondaryTab>
                      ),
                    )}
                </SecondaryTabList>
                <DocumentArchiveButton
                  mt={4}
                  px={4}
                  maxW="276px"
                  folderId={folderId}
                  kind="administrative"
                  label="Télécharger le dossier administratif"
                />
              </Box>

              <TabPanels>
                {formik.values.eligibleFundersMonitoring &&
                  Object.keys(formik.values.eligibleFundersMonitoring).map(key => (
                    <TabPanel key={key}>
                      <BlocGTabForm
                        pending={pending}
                        fieldPrefix={`eligibleFundersMonitoring.${key}`}
                        funderName={key}
                        needOwnerAutorisation={needOwnerAutorisation}
                        hasWorks={hasWorks}
                        hasOwnerAuthorizedWorks={formik.values.hasOwnerAuthorizedWorks}
                      />
                    </TabPanel>
                  ))}
              </TabPanels>
            </Flex>
          </Tabs>
        ) : null
      }
    </BlocFormik>
  );
};
